import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.81 1.36c1.9 0 3.44 7.9 3.44 17.64H22c0-10.5-2.77-19-6.19-19-1.94 0-3.68 2.56-4.81 6.55C9.87 2.55 8.13 0 6.19 0 2.77 0 0 8.5 0 19h2.75c0-9.74 1.54-17.64 3.44-17.64s3.43 7.29 3.43 16.28h2.76c0-9 1.53-16.28 3.43-16.28z" fill="#FFBC0D" /></svg>);